export default class ApiService {

    static get $inject() {
        return [
            '$q', '$http', 'ApiService', 'CookiesService', 'PermissionsService'
        ];
    }

    constructor($q, $http, ApiService, CookiesService, PermissionsService) {

        this._api = ApiService.api;
        this.$q = $q;
        this.$http = $http;
        this.CookiesService = CookiesService;
        this.PermissionsService = PermissionsService;
        this.accessToken = null;
        this.getUserDetails();
    }

    getEventsTypesList() {
        return this.$http.get(this._api + `/config/event_types/`);
    }

    setUserDetails(firstName, lastName) {

        return this.$http({
            url: this._api + '/auth/user/',
            method: 'PUT',
            data: {
                'username': this.getUserName(),
                'first_name': firstName,
                'last_name': lastName
            }
        })
    }

    getUserFirstName() {

        let details = this.getDetails();

        if (details) {
            return details.first_name
        }
        else {
            return '';
        }
    }

    getUserLastName() {

        let details = this.getDetails();

        if (details) {
            return details.last_name;
        }
        else {
            return '';
        }
    }

    getUserName() {

        let details = this.getDetails();

        if (details) {
            return details.username;
        }
        else {
            return '';
        }
    }

    getUserPk() {

        let details = this.getDetails();

        if (details) {
            return details.pk;
        }
        else {
            return '';
        }
    }

    getEmail() {

        let details = this.getDetails();

        if (details) {
            return details.email;
        }
        else {
            return '';
        }
    }

    getUserDetails() {

        if (this.CookiesService.getCookie('token')) {
            return this.$http({
                url: this._api + '/auth/user/',
                method: 'GET'
            })
                .then(resp => {
                    this.userDetalis = resp.data;
                    this.PermissionsService.setPermissions(this.userDetalis.permissions);

                })
                .catch(err => {
                    this.userDetalis = {};
                    return err;
                });
        }
    }

    getUserFullName() {
        let fullUserName = this.getUserLastName() + ' ' + this.getUserFirstName();
        return fullUserName;
    }

    getDetails() {
        return this.userDetalis;
    }

    update(data) {
        return this.$http({
            url: this._api + '/account',
            method: 'PUT',
            data: data
        });
    }

    changePassword(data) {
        return this.$http({
            url: this._api + '/auth/password/change/',
            method: 'POST',
            data: data
        });
    }

    saveEndPointToken(token) {

        this.accessToken = token;
    }

    setEndPoint() {

        if (this.accessToken && this.CookiesService.getCookie('token')) {

            return this.$http({
                url: this._api + '/user_actions/endpoint/',
                method: 'POST',
                data: {
                    'token': this.accessToken
                }
            });
        }
    }

    getBrowserDefaultLanguage() {

        return this.$http({
            url: this._api + '/general/language/',
            method: 'GET'
        })
    }

    getTermOfService() {
        return this.$http.get(`${this._api}/general/tos/`);
    }

}


/** WEBPACK FOOTER **
 ** ./src/services/api/api.account.service.js
 **/